
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withTranslationWrapper } from "../../HOC";
import {
  checkPrivileges,
  errorHandler,
} from "../../Helpers";
import Layout from "../../Layout";
import TextField from "../../Components/common/TextField";
import Button from "../../Components/common/Button";
import Grid from "@mui/material/Grid";
import EmptyState from "../../Components/common/EmptyState";
import ConfirmDialog from "../../Components/common/ConfirmDialoag";
import instance from "../../axios";
import { addCategories, fetchCategories, getCategories } from "../../Actions/Categories";
import { notifySuccess } from "../../Utils";
import { Redirect } from "react-router-dom/cjs/react-router-dom";
import { fetchDevices } from "../../Actions/Devices";

const Categories = (props) => {
  const dispatch = useDispatch();
  const logInUser = useSelector((s) => s.logInUsers);
  const serverSettings = useSelector((s) => s.ServerSetting);
  const themeColors = useSelector((s) => s.themeColors);
  const services = useSelector((s) => s.services);

  const [state, setState] = useState({
    categoryForm: {},
    mode: "",
    searchText: "",
    currentPage: 1,
    pageSize: 50,
    deleteForm: {},
    onDeleteConfirmation: false,
    isVisibleSubmitBtn: false,
    servicesData: [],
    itemPagination: { items: [], total: 0, hasNext: true },
    loading: false,
  });

  const fetchData = useCallback(
    async (page, limit, append = false, search = "") => {
      try {
        const url = logInUser ? `/api/devicetypes?contractNumber=${serverSettings?.contractNumber || ""}` : `/api/devicetypes?contractNumber=${serverSettings?.contractNumber || ""}&page=${page}&limit=${limit}`

        const data = await instance.get(url, {
          headers: { Accept: "application/json" },
          params: { search },
        });
        const newItems = Array.isArray(data)
          ? data
          : Array.isArray(data)
            ? data
            : [];

        setState((prev) => {
          const merged = append
            ? [...prev.itemPagination.items, ...newItems]
            : newItems;
          return {
            ...prev,
            itemPagination: {
              items: merged,
              total: data?.total || merged.length,
              hasNext: data?.hasNext ?? false,
            },
            servicesData: merged,
          };
        });

        dispatch(getCategories(newItems));
      } catch (error) {
        errorHandler(error, dispatch);
      }
    },
    [dispatch, serverSettings]
  );


  useEffect(() => {
    if (logInUser?.id && serverSettings) {
      fetchData(
        state.currentPage,
        state.pageSize,
        false,
        state.searchText
      );
    }
  }, [logInUser, state.searchText, state.currentPage, state.pageSize, fetchData, serverSettings]);
  useEffect(()=>{
   return()=>{
      dispatch(fetchCategories(serverSettings))
    }
  },[])

  const handleChange = (name, value) => {
    setState((prev) => ({
      ...prev,
      categoryForm: { ...prev.categoryForm, [name]: value },
    }));
  };


  useEffect(() => {
    const { label, name } = state.categoryForm;
    const valid = Boolean(label || name);
    setState((prev) => ({ ...prev, isVisibleSubmitBtn: valid }));
  }, [state.categoryForm]);


  const searchItems = (text) => {
    setState((prev) => ({
      ...prev,
      searchText: text,
      currentPage: 1,
    }));
  };

  const fetchMoreItems = () => {
    if (state.itemPagination.hasNext) {
      const nextPage = state.currentPage + 1;
      setState((prev) => ({ ...prev, currentPage: nextPage }));
      fetchData(nextPage, state.pageSize, true, state.searchText);
    }
  };

  const openCreateForm = () =>
    setState((prev) => ({
      ...prev,
      mode: "create",
      categoryForm: {},
      isVisibleSubmitBtn: false,
    }));

  const openEditForm = (data) =>
    setState((prev) => ({
      ...prev,
      mode: "edit",
      categoryForm: data,
      isVisibleSubmitBtn: false,
    }));

  const closeForm = () =>
    setState((prev) => ({
      ...prev,
      mode: "",
      categoryForm: {},
      isVisibleSubmitBtn: false,
    }));


  const removeCategory = async () => {
    try {
      const id = state.deleteForm.id;
      await instance.delete(`/api/devicetypes/${id}`);
      dispatch(notifySuccess("subTypeIsDeleted"));
      setState((prev) => ({
        ...prev,
        deleteForm: {},
        onDeleteConfirmation: false,
      }));
      fetchData(1, state.pageSize);
    } catch (error) {
      errorHandler(error, dispatch);
    }
  };


  const submitForm = async () => {
    const { mode, categoryForm } = state;
    const isEdit = mode === "edit";

    const api = isEdit
      ? `/api/devicetypes/${categoryForm.id}`
      : `/api/devicetypes`;

    const payload = {
      ...categoryForm,
      parentId: logInUser.id,
      dtype: categoryForm.label,
      contractNumber: serverSettings?.contractNumber || "",
    };

    try {
      setState((prev) => ({ ...prev, loading: true}));

      const data = await instance({
        url: api,
        method: isEdit ? "PUT" : "POST",
        headers: { Accept: "application/json" },
        data: payload,
      });

      dispatch(addCategories(data));
      dispatch(notifySuccess(isEdit ? "categoriesUpdated" : "categoriesCreated"));
      closeForm();
        if(checkPrivileges("device")){
                  dispatch(fetchDevices(logInUser, true))
        }
      fetchData(1, state.pageSize);
    } catch (error) {
      errorHandler(error, dispatch);
    } finally {
      setState((prev) => ({ ...prev, loading: false,searchText:""}));
    }
  };



  const onCancel = () =>
    setState((prev) => ({
      ...prev,
      onDeleteConfirmation: false,
      isVisibleSubmitBtn: false,
    }));

  const endMessage = (
    <p style={{ textAlign: "center", color: "#ccc" }}>
      -- {props.translate("end")} --
    </p>
  );

  if (!checkPrivileges("devicetype")) return <Redirect to="/dashboard"/>;

  const layoutProps = {
    ...props,
    services,
    endMessage,
    openCreateFrom: openCreateForm,
    onEditType: openEditForm,
    searchItems,
    fetchMoreItems,
    searchText: state.searchText,
  };

  return (
    <Layout {...layoutProps} classFromChildren="has-padding" {...state}>
      <div className="main-content-page">
        {state.onDeleteConfirmation && (
          <ConfirmDialog
            onCancel={onCancel}
            onOk={removeCategory}
            title={props.translate("areYouWantToDelete")}
          >
            {state.deleteForm?.name || state.deleteForm?.label || ""}
          </ConfirmDialog>
        )}

        <div
          style={{
            background: themeColors.backgroundColor,
            color: themeColors.textColor,
            borderRadius: 6,
            padding: 16,
          }}
        >
          {["create", "edit"].includes(state.mode) ? (
            <EditForm
              form={state.categoryForm}
              handleChange={handleChange}
              translate={props.translate}
              submitForm={submitForm}
              closeForm={closeForm}
              mode={state.mode}
              isVisibleSubmitBtn={state.isVisibleSubmitBtn}
              loading={state.loading}
            />
          ) : (
            <EmptyState text={props.translate("noServicesSelected")} />
          )}
        </div>
      </div>
    </Layout>
  );
};

const EditForm = ({
  form,
  handleChange,
  translate,
  submitForm,
  closeForm,
  mode,
  isVisibleSubmitBtn,
  loading
}) => (
  <div>
    <h4 className="page-title">{translate("vehicleType")}</h4>
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id="label"
          required
          margin="dense"
          label={translate("label")}
          variant="outlined"
          fullWidth
          value={form.label || ""}
          onChange={(e) => handleChange("label", e.target.value)}
        />
      </Grid>
    </Grid>
    <div style={{ display: "flex", marginTop: 10 }}>
      <div style={{ marginLeft: "auto" }} />
      <Button
        size="small"
        style={{ marginRight: 15 }}
        className="button-white"
        onClick={closeForm}
      >
        {translate("sharedCancel")}
      </Button>
      {checkPrivileges("devicetypeCreate") && (
        <Button
          size="small"
          onClick={submitForm}
          disabled={!isVisibleSubmitBtn || loading}
        >
          {loading
            ? translate("loading") + "..."
            : translate(mode === "edit" ? "update" : "sharedCreate")}
        </Button>

      )}
    </div>
  </div>
);

export default withTranslationWrapper(Categories);
